(() => {
  const config = document.getElementById('sh-cart-feedback');
  if (!config) return;
  const refreshCount = async () => {
    try {
      const response = await fetch(config.dataset.cartJsonUrl, { credentials: 'same-origin', headers: { Accept: 'application/json' } });
      if (!response.ok) return;
      const cart = await response.json();
      document.querySelectorAll('[data-sh-cart-count]').forEach(node => { node.textContent = ` (${cart.item_count})`; });
    } catch (_) { /* Keep the server-rendered count if the connection fails. */ }
  };
  document.addEventListener('cart:update', event => {
    const detail = event.detail?.data;
    if (detail?.source === 'product-form-component' && !detail.didError) {
      window.location.assign(config.dataset.cartUrl);
      return;
    }
    refreshCount();
  });
  window.addEventListener('pageshow', event => { if (event.persisted) refreshCount(); });
})();
